export default function createSortByString(
  originalSkinElement: any,
  accSkinOneElement: any,
  accSkinTwoElement: any,
  accSkinThreeElement: any,
  accessibilityData: any,
) {
  switch(accessibilityData.siteAccessibilityColour) {
    case "SiteAccessibilityYellow":
      return accSkinOneElement;
    case "SiteAccessibilityWhite":
      return accSkinTwoElement;
    case "SiteAccessibilityBlack":
      return accSkinThreeElement;      
    default:
      return originalSkinElement;
  } 
}